<template>
  <div>
    <el-dialog title="图片管理" :visible.sync="dialoguploadVisible" :show-close="true" width="720px" :before-close="onClose">
      <div class="upload">
        <div class="upload_header">
          <div class="tab-line">
            <div
              class="tab-item1"
              @click="hugItemBtn(1)"
              :class="{ active: table == 1 }"
              :style="{
                color: table == 1 ? '#ff3d59' : '',
                'border-top': table == 1 ? '2px solid ' + '#ff3d59' : '',
                'background-color': table != 1 ? '#F9F9F9' : '#fff',
                'background-color': table != 1 ? '#F9F9F9' : '#fff',
              }"
            >
              <div
                v-if="table == 1"
                style="
                    width: 130px;
                    height: 2px;
                    position: absolute;
                    background-color: #fff;
                    margin-top: 36px;
                  "
              ></div>
              {{ messageOne }}
            </div>
            <div
              class="tab-item1"
              @click="hugItemBtn(2)"
              :class="{ active: table == 2 }"
              :style="{
                color: table == 2 ? '#ff3d59' : '',
                'border-top': table == 2 ? '2px solid ' + '#ff3d59' : '',
                'background-color': table != 2 ? '#F9F9F9' : '#fff',
                'background-color': table != 2 ? '#F9F9F9' : '#fff',
              }"
            >
              <div
                v-if="table == 2"
                style="
                    width: 130px;
                    height: 2px;
                    position: absolute;
                    background-color: #fff;
                    margin-top: 36px;
                  "
              ></div>
              {{ messageTwo }}
            </div>
          </div>
        </div>
        <!-- 上传图片 -->
        <div v-if="table == 1">
          <div class="upload_main">
            <el-form :model="uploadform" ref="formupload" style="margin-top: 20px; margin-left: 50px">
              <el-form-item label="上传图片:" prop="src">
                <div style="float:left">
                  <div class="upload_img_box">
                    <img class="upload_img" :src="uploadform.src" v-if="uploadform.src" />
                  </div>
                  <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    accept=".jpg,.png"
                    ref="upload"
                    :before-upload="beforeimageUpload"
                    :show-file-list="false"
                    style="width: 120px; margin-top: -10px"
                  >
                    <el-button class="uploadsrc" style="margin-top: 15px;" size="mini">上传图片</el-button>
                  </el-upload>
                </div>
                <div style="float:left;line-height:24px">
                  <div>建议上传尺寸：65px*65px</div>
                  <div>图片大小：300K以内</div>
                  <div>格式：jpg、png、gif</div>
                </div>
              </el-form-item>
              <!-- <el-form-item style="margin-left: 70px; width: 250px">
                  <div>建议上传尺寸：200px*200px</div>
                  <div>图片大小：300K以内</div>
                  <div>格式：jpg、png</div>
                </el-form-item> -->
              <el-form-item label="图片名称:" prop="name">
                <el-input v-model="uploadform.name" autocomplete="off" style="width: 250px"></el-input>
              </el-form-item>
              <el-form-item label="">
                <div style="transform:translate(66px, -11px);color:#b1b1b1">若不设置则使用上传的图片文件名</div>
              </el-form-item>
            </el-form>
          </div>
          <div class="upload_footer">
            <el-button @click="onClose" class="status_btn2">取消</el-button>
            <el-button class="status_btn3" @click="comfireUpload">确定</el-button>
          </div>
          <div class="line"></div>
        </div>

        <!-- 图片库 -->
        <div class="gallery" v-if="table == 2">
          <div class="gallery_header">
            <el-button class="btn" size="mini" :class="{ active: gallerytype == 1 }" @click="gallerytype = 1">系统图标</el-button>
            <el-button class="btn" size="mini" :class="{ active: gallerytype == 2 }" @click="gallerytype = 2">自定义</el-button>
          </div>

          <div class="gallery_main" v-if="gallerytype == 1">
            <ul>
              <li
                :class="active == index ? 'gallery_active' : 'gallery_li'"
                v-for="(item, index) in gallery"
                @click="clickScript(index)"
                :key="index"
              >
                <img class="gallery_img" :src="item.imageUrl" alt="" />
                <span>{{ item.imageName }}</span>
              </li>
            </ul>
            <div class="pagination">
              <el-pagination
                background
                style="
                    text-align: right;
                    margin-top: 30px;
                    margin-right: 17px;
                    padding-bottom: 20px;
                  "
                @size-change="gallerySizeChange"
                @current-change="galleryCurrentChange"
                :current-page="sellerImageform1.current"
                :page-sizes="[10, 20, 30, 50, 100, 500]"
                :page-size="sellerImageform1.size"
                layout="total, prev,sizes, pager, next, jumper"
                :total="gallerycrowdTotal"
              ></el-pagination>
            </div>
            <div class="gallery_footer">
              <el-button @click="onClose" class="status_btn2">取消</el-button>
              <el-button class="status_btn3" @click="galleryUrl">确定</el-button>
            </div>
          </div>
          <div class="gallery_main" v-if="gallerytype == 2">
            <ul>
              <li
                :class="active == index ? 'gallery_active' : 'gallery_li'"
                v-for="(item, index) in mygallery"
                @click="clickScript(index)"
                :key="index"
              >
                <img class="gallery_img" :src="item.imageUrl" alt="" />
                <span>{{ item.imageName }}</span>
              </li>
            </ul>
            <!-- 分页 -->
            <div class="pagination">
              <el-pagination
                background
                style="
                    text-align: right;
                    margin-top: 30px;
                    margin-right: 17px;
                    padding-bottom: 20px;
                  "
                @size-change="MygallerySizeChange"
                @current-change="MygalleryCurrentChange"
                :current-page="sellerImageform2.current"
                :page-sizes="[10, 20, 30, 50, 100, 500]"
                :page-size="sellerImageform2.size"
                layout="total, prev,sizes, pager, next, jumper"
                :total="mycrowdTotal"
              ></el-pagination>
            </div>
            <div class="gallery_footer">
              <el-button @click="onClose" class="status_btn2">取消</el-button>
              <el-button class="status_btn3" @click="myUrl">确定</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { sellerImageList, addImage } from "../../api/integralCenter/suspensionDiagram";
import { uploadImage } from "../../api/file/file-controller";
export default {
  name: "",
  props: {
    dialoguploadVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploadform: {
        src: "", //悬浮图标
        name: "",
      },
      table: 1,
      messageOne: "上传图片",
      messageTwo: "图片库",
      gallerytype: 1,
      //系统图标
      gallery: [],
      //自定义图标
      mygallery: [],
      sellerImageform1: {
        current: 1, //页码
        imageName: "", //图片名
        size: 10,
        type: 1,
        businessType: 1,
      },
      gallerycrowdTotal: 0,
      sellerImageform2: {
        current: 1, //页码
        imageName: "", //图片名
        size: 10,
        type: 2,
        businessType: 1,
      },
      mycrowdTotal: 0,
      active: -1,
    };
  },
  methods: {
    onClose() {
      this.$emit("on-close");
      console.log("close");
    },
    comfireUpload() {
      if (this.uploadform.src != "") {
        let data = {
          type: 2,
          businessType: 1,
          imageUrl: this.uploadform.src,
          imageName: this.uploadform.name ? this.uploadform.name : this.fileName.substring(0, this.fileName.length - 4),
        };
        addImage(data)
          .then(() => {
            this.$message.success("上传成功");
            this.getsellerImageList2();
            this.table = 2;
            this.gallerytype = 2;
          })
          .catch((res) => {
            this.$message.error(res.error);
          });
      } else {
        this.$message.error("请添加图片");
      }
    },
    //图片库切换事件
    hugItemBtn(type) {
      this.table = type;
      if (type === 2) {
        this.getsellerImageList1();
        this.getsellerImageList2();
      }
    },
    beforeimageUpload(file) {
      console.log(file);
      let _this = this;
      let forms = new FormData();
      let icon = true;
      forms.append("file", file);
      forms.append("isIcon", true);
      console.log(forms);
      this.fileName = file.name;
      if (file.size > 30000) {
        this.$message.warning("图片大于300kb");
        return;
      }
      uploadImage(forms).then((res) => {
        this.uploadform.src = res.data;
        console.log(this.uploadform.src);
      });
      return false;
    },
    cancelUpload() {
      this.uploadform.src = "";
      this.dialoguploadVisible = false;
    },
    //获取图片库图片
    getsellerImageList1() {
      sellerImageList(this.sellerImageform1)
        .then((res) => {
          this.gallery = res.data.records;
          this.gallerycrowdTotal = parseInt(res.data.total);
          // this.$message.success("查询成功");
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    getsellerImageList2() {
      //自定义
      sellerImageList(this.sellerImageform2)
        .then((res) => {
          this.mygallery = res.data.records;
          this.mycrowdTotal = parseInt(res.data.total);
          // this.$message.success("查询成功");
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    //图片库分页变化
    gallerySizeChange(val) {
      this.sellerImageform1.size = val;
      this.getsellerImageList1();
    },
    galleryCurrentChange(val) {
      this.sellerImageform1.current = val;
      this.getsellerImageList1();
    },
    MygallerySizeChange(val) {
      this.sellerImageform2.size = val;
      this.getsellerImageList2();
    },
    MygalleryCurrentChange(val) {
      this.sellerImageform2.current = val;
      this.getsellerImageList2();
    },
    galleryUrl() {
      let index = this.active;
      // console.log(this.gallery[index].imageUrl)
      this.$emit("on-confirm", this.gallery[index].imageUrl);
      // this.createform.imageUrl = this.gallery[index].imageUrl;
      // this.dialoguploadVisible = false;
      // console.log(this.createform.imageUrl);
    },
    clickScript(index) {
      console.log(index);
      this.active = index;
    },
    myUrl() {
      let index = this.active;
      this.$emit("on-confirm", this.mygallery[index].imageUrl);
      // this.createform.imageUrl = this.mygallery[index].imageUrl;
      // this.dialoguploadVisible = false;
    },
  },
  mounted() {
    this.getsellerImageList1();
    // sellerImageList({type:1,current:1,size:10}).then(res=>{
    //     console.log(res)
    // })
  },
};
</script>

<style scoped lang="scss">
.upload {
  width: 670px;
  margin-top: -20px;
  .upload_header {
    .tab-line {
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #dddddd;
      // margin: 20px 28px 0 28px;
      .tab-item1 {
        text-align: center;
        width: 130px;
        height: 36px;
        line-height: 36px;
        display: inline-block;
        position: relative;
        cursor: pointer;
        margin-right: 2px;
        border: 1px solid #dddddd;
        border-bottom: none;
        span {
          position: absolute;
          width: 100%;
          left: 50%;
          height: 2px;
          transform: translateX(-50%);
          bottom: -2px;
          display: none;
        }
        &.active {
          border-top: 2px;
          span {
            display: block;
            background: #fff;
          }
        }
      }
    }
  }
  .upload_main {
    padding-bottom: 50px;

    .uploadsrc {
      color: #ff3d59;
      border: 1px solid #ff3d59;
      border-radius: 3px;
      background-color: #fff4f4;
      &:hover {
        color: #fff;
        background-color: #ff3d59;
      }
      &:active {
        color: #fff;
        border: 1px solid #ff3d59;
        background-color: #fff4f4;
      }
    }
    .upload_img_box {
      border: 1px solid #f0f0f0;
      display: inline-block;
      width: 90px;
      height: 90px;
      // margin-left: 60px;
      margin-top: -10px;
      .upload_img {
        width: 90px;
        height: 90px;
        margin-top: 10px;
      }
    }
  }
  .upload_footer {
    position: absolute;
    // left: calc(50% - 100px);
    bottom: 20px;
    right: 28px;

    .status_btn2 {
      width: 98px;
      height: 32px;
      color: #999999;
      padding: 5px 12px;
      border-radius: 3px;
      border: 1px solid #cccccc;
      background-color: #fff;
      &:hover {
        color: #ff3d59;
        border: 1px solid #ff3d59;
        background-color: #fff4f4;
      }
      &:active {
        color: #ff3d59;
        border: 1px solid #ff3d59;
        background-color: #fff4f4;
      }
    }
    .status_btn3 {
      width: 98px;
      padding: 5px 12px;
      height: 32px;
      color: #ff3d59;
      border: 1px solid #ff3d59;
      border-radius: 3px;
      background-color: #fff4f4;
      &:hover {
        color: #fff;
        background-color: #ff3d59;
      }
      &:active {
        color: #fff;
        border: 1px solid #ff3d59;
        background-color: #fff4f4;
      }
    }
  }
  .line {
    position: absolute;
    width: 100%;
    height: 1px;
    left: 0px;
    bottom: 1px;
    // background-color: black;
  }

  .gallery {
    padding-bottom: 50px;
    width: 700px;
    .gallery_header {
      margin-top: 30px;

      .btn {
        &:hover {
          color: black;
          // border: 1px solid #ff3d59;
          background-color: #fff;
        }
      }

      .active {
        color: black;
        border: 1px solid #ff3d59;
        background-color: #fff;
      }
    }
    .gallery_main {
      margin-top: 20px;
      width: 700px;
      overflow-x: hidden;
      ul {
        display: flex;
        flex-wrap: wrap;
        height: 300px;
        width: 720px;
        // border: 1px solid red;
        overflow-y: auto;
        .gallery_li {
          width: 115px;
          // height: 115px;
          margin-right: 25px;
          margin-bottom: 20px;
          text-align: center;
          // border: 1px solid blue;
          .gallery_img {
            width: 100%;
            height: 115px;
          }
        }
        .gallery_active {
          width: 115px;
          // height: 115px;
          margin-right: 25px;
          margin-bottom: 20px;
          text-align: center;
          .gallery_img {
            width: 100%;
            height: 115px;
            border: 1px solid red;
          }
        }
      }
    }
    // .pagination {
    // }
    .gallery_footer {
      position: absolute;
      right: 20px;
      // bottom: 60px;
      .status_btn2 {
        width: 98px;
        height: 32px;
        color: #999999;
        padding: 5px 12px;
        border-radius: 3px;
        border: 1px solid #cccccc;
        background-color: #fff;
        &:hover {
          color: #ff3d59;
          border: 1px solid #ff3d59;
          background-color: #fff4f4;
        }
        &:active {
          color: #ff3d59;
          border: 1px solid #ff3d59;
          background-color: #fff4f4;
        }
      }
      .status_btn3 {
        width: 98px;
        padding: 5px 12px;
        height: 32px;
        color: #ff3d59;
        border: 1px solid #ff3d59;
        border-radius: 3px;
        background-color: #fff4f4;
        &:hover {
          color: #fff;
          background-color: #ff3d59;
        }
        &:active {
          color: #fff;
          border: 1px solid #ff3d59;
          background-color: #fff4f4;
        }
      }
    }
  }
}
.gallery_active {
  width: 115px;
  // height: 115px;
  margin-right: 25px;
  margin-bottom: 20px;
  text-align: center;
  .gallery_img {
    width: 100%;
    height: 115px;
    border: 1px solid red;
  }
}
.gallery_li {
  width: 115px;
  // height: 115px;
  margin-right: 25px;
  margin-bottom: 20px;
  text-align: center;
  // border: 1px solid blue;
  .gallery_img {
    width: 100%;
    height: 115px;
  }
}
</style>
